import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';

import { environment } from '../../environments/environment';

const decamelizeKeysDeep = require('decamelize-keys-deep');

@Injectable()
export class ConsultationRoomService {
  baseUrl = environment.serverUrl;

  constructor(private http: Http) { }

  generateToken() {
    let params = {};
    params = decamelizeKeysDeep(params);

    let headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.baseUrl + '/generate-room/', params, { headers: headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/consultation-room/consultation-room.service.ts